export enum PropertySchema {
  Immobiliare_it = 'immobiliare.it',
  Idealista_it = 'idealista.it',
  External = 'external',
}
